import React from "react"
import { Box, ButtonBase, Tooltip, Typography } from "@material-ui/core"
import clsx from "clsx"

import useStyles from "@/components/ChatMessageBuilder/AIEquivalentVariation/styles"
import SvgIcon from "@/components/SvgIcon"
import { AIIcon } from "@/assets/icons"
import { colors } from "@/styles/colors"

type AIEquivalentVariationProps = {
	onSave: (enabled: boolean) => Promise<void>
	enabled: boolean
	ButtonProps?: {
		disabled?: boolean
		disabledTooltipText?: string
	}
}

export type AIVariationTabBarProps = AIEquivalentVariationProps

export const AIVariationTabBar: React.FC<AIVariationTabBarProps> = ({ enabled, onSave, ButtonProps }) => {
	const classes = useStyles()

	const handleFixedTextClick = (event: React.MouseEvent) => {
		event.stopPropagation()
		if (enabled) {
			onSave(false)
		}
	}

	const handleAIVariationClick = (event: React.MouseEvent) => {
		event.stopPropagation()
		onSave(!enabled)
	}

	const aiVariationTab = ButtonProps?.disabled ? (
		<Tooltip title={ButtonProps?.disabledTooltipText ?? ""}>
			<Box className={classes.tabDisabledWrapper}>
				<Box className={clsx(classes.tab, classes.tabDisabledContent)}>
					<SvgIcon
						icon={AIIcon}
						fontSize="inherit"
						autoSize
						className={classes.infoIcon}
					/>
					Variar com IA
				</Box>
			</Box>
		</Tooltip>
	) : (
		<ButtonBase
			className={clsx(classes.tab, { [classes.tabActive]: enabled })}
			onClick={handleAIVariationClick}
		>
			<SvgIcon
				icon={AIIcon}
				fontSize="inherit"
				autoSize
				className={classes.infoIcon}
			/>
			Variar com IA
		</ButtonBase>
	)

	return (
		<Box className={classes.tabBarWrapper}>
			<Box className={classes.tabBar}>
				<ButtonBase
					className={clsx(classes.tab, { [classes.tabActive]: !enabled })}
					onClick={handleFixedTextClick}
				>
					Texto Fixo
				</ButtonBase>

				{aiVariationTab}
			</Box>
		</Box>
	)
}

export const AIVariationInfoText: React.FC<{ onDeactivate: () => void }> = ({ onDeactivate }) => {
	const classes = useStyles()

	const handleDeactivateClick = (event: React.MouseEvent) => {
		event.stopPropagation()
		onDeactivate()
	}

	return (
		<Box className={classes.infoText}>
			<SvgIcon
				icon={AIIcon}
				fontSize="inherit"
				autoSize
				className={classes.infoIcon}
				color="primary"
			/>
			<Typography variant="caption" style={{ color: colors.purple[500] }}>
				{"A IA vai variar esta mensagem automaticamente. Toque em "}
				<span
					className={classes.primaryText}
					onClick={handleDeactivateClick}
				>
					Texto Fixo
				</span>
				{" para desativar."}
			</Typography>
		</Box>
	)
}
